<div [hidden]="showRequest">



  <!-- <div class="form-container">
      <h4 class="section-title">
        Actions To be taken
      </h4>
      <a *ngIf="formMode!=FormMode.Add && !loggedInUser?.IsAdmin && !baseRequestDTO.IsExpired && baseRequestDTO.IsCompleted && validFees && hasTransit"
      class="btn" (click)="applyTransitRequest()">
      {{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.APPLY_TRANSIT' | translate}}
    </a>
  </div> -->

  <h2 *ngIf="!IsAdminMode" class="sectionTitle">{{'FRONT_USER.FEES_ESTIMATION_FORM.FORM' | translate }}
  </h2>

  <!--request Details summary-->
  <app-request-details *ngIf="feesRequestId" [baseRequest]="baseRequestDTO"></app-request-details>

  <div *ngIf="hasTransit" class="bs-callout bs-callout-info">
    <h4>{{'FRONT_USER.FEES_ESTIMATION_FORM.TRANSIT_RELATED_REQUEST' | translate}}</h4>
    <p>{{'FRONT_USER.FEES_ESTIMATION_FORM.TRANSIT_RELATED' | translate}} <a
        (click)="getTransitByParentId()">{{TransitRequestNumber}}</a></p>
  </div>

  <div *ngIf="formMode!=FormMode.Add && !loggedInUser?.IsAdmin && !baseRequestDTO?.IsCancelled" class="form-container">

    <h4 class="section-title">
      {{ 'FRONT_USER.ACTION_TO_BE_TAKEN' | translate }}
    </h4>

    <div class="clearfix"></div>

    <div class="form-group" style="display: block; margin-bottom: 15px;">
      <div ngbDropdown class="dropdown inline-block">
        <button ngbDropdownToggle id="request-action-menu" type="button" aria-haspopup="true" aria-expanded="false"
          class="btn btn-default">
          {{ 'FRONT_USER.TAKE_ACTION' | translate }}
          <span class="caret"></span>
        </button>
        <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="request-action-menu">
          <li>
            <a class="btn" *ngIf="!hasTransit && !baseRequestDTO?.IsExpired" (click)="applyTransitRequest()">
              {{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.APPLY_TRANSIT' | translate}}
            </a>
            <a class="btn" *ngIf="!baseRequestDTO?.IsExpired" Confirmation (confirmationClick)="cancelFeesRequest()">
              {{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.CANCEL_FEES_ESTIMATION' | translate}}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="hasActiveTransitError" style="clear: both; width: 100%; display: block; padding-top: 10px;">
      <div class="alert alert-danger mb-0" role="alert" style="font-weight: bold; margin: 0;">
        {{'FRONT_USER.ERRORS_MESSAGES.MUST_CANCEL_TRANSIT_FIRST' | translate}}
      </div>
    </div>

    <!-- رسالة الخطأ 2: في حالة وجود Transit مكتمل (Completed) -->
    <div *ngIf="hasCompletedTransitError" style="clear: both; width: 100%; display: block; padding-top: 10px;">
      <div class="alert alert-danger mb-0" role="alert" style="font-weight: bold; margin: 0;">
        {{'FRONT_USER.ERRORS_MESSAGES.CANNOT_CANCEL_FEES_TRANSIT_COMPLETED' | translate}}
      </div>
    </div>

  </div>


  <div
    *ngIf="(!loggedInUser?.IsAdmin && formMode!=FormMode.Add && requestStatus == ServiceStatus.MoreInformationRequestedFromAgent)|| isCompleted">
    <div class="form-container"
      [style.background-color]="requestStatus == ServiceStatus.MoreInformationRequestedFromAgent ? '#fff8e1' : ''"
      [style.border]="requestStatus == ServiceStatus.MoreInformationRequestedFromAgent ? '1px solid #f0ad4e' : ''"
      [style.border-radius]="'6px'" [style.padding]="'10px'">
      <h4 class="section-title">

        {{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.REQUIRED_INFORMATION'| translate}}
      </h4>
      <div class="form-group">
        <label for="MoreInformationFees">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
          translate}}</label>
        <textarea [(ngModel)]="moreInfomation" id="MoreInformationFees" name="MoreInformationFees" disabled
          class="form-control"></textarea>
      </div>
    </div>
  </div>


  <form [formGroup]="feesEstimationForm" #feesEstimation>
    <div>
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>
      </div>
      <tabset #FeesTabs>

        <tab heading="{{ 'FRONT_USER.AGENT_TABS.AGENT_INFO' | translate}}">
          <agent-basic-info #tabOneControls [agentId]="agentId" (isTabOneValid)="receiveTabOneValidity($event)"
            (agentEvent)="receiveCurrency($event)" [FeesTabs]="FeesTabs" [currencyId]="currencyId" [FormMode]="formMode"
            formControlName="agentInfo">
          </agent-basic-info>
        </tab>

        <tab #tabTwoControls heading="{{ 'FRONT_USER.FEES_ESTIMATION_TABS.VESSEL_PARTICULARS' | translate}}"
          [disabled]="!isTabOneValid">
          <div class="form-container">
            <div class="form-group">
              <label for="VesselName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VESSEL_NAME' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="VesselName" id="VesselName" class="form-control" formControlName="VesselName" />
              <div *ngIf="isTabTwoSubmitted || (f.VesselName?.dirty && f.VesselName?.errors)" class="red ">
                <div *ngIf="f.VesselName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="SCID">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SCID' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="SCID" id="SCID" class="form-control" formControlName="SCID" />
              <div *ngIf="isTabTwoSubmitted || (f.SCID?.dirty && f.SCID?.errors)" class="red ">
                <div *ngIf="f.SCID?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.SCID?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
              </div>

            </div>
            <div class="form-group">
              <label for="IMONO">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.IMONO' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="IMONO" id="IMONO" class="form-control" formControlName="IMONO"
                (input)="checkFeesEstimationOfSameVessel()" />
              <div *ngIf="isTabTwoSubmitted || (f.IMONO?.dirty && f.IMONO?.errors)" class="red ">
                <div *ngIf="f.IMONO?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.IMONO?.errors?.pattern">{{'FRONT_USER.IMO_ERROR' | translate}}</div>
                <div *ngIf="f.IMONO?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.IMONO?.hasError('sameVesselHasRequest')">
                  {{ 'FRONT_USER.FEES_ESTIMATION_FORM.SAME_VESSEL_REQUEST_MESSAGE' | translate}}
                  <a
                    (click)="goToFessEstimationOfSameIMONO(sameVesselRequestsData.Id)">{{sameVesselRequestsData.RequestNumber}}</a>.
                </div>

                <!-- <div *ngIf="errorIMO.isError" class="red">
                  {{ errorIMO.errorMessage }}
                </div> -->
              </div>
            </div>
            <div class="form-group">
              <label for="CallSign">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.CALL_SIGN' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="CallSign" id="CallSign" class="form-control" formControlName="CallSign" />
              <div *ngIf="isTabTwoSubmitted || (f.CallSign?.dirty && f.CallSign?.errors)" class="red ">
                <div *ngIf="f.CallSign?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="ShipTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_TYPE'| translate}}</label>
              <span class="red">*</span>
              <select (change)="ChangingShip($event)" formControlName="ShipTypeId" class="form-control">
                <option [value]='null' selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_TYPE_CHOOSE' | translate}}
                </option>
                <ng-container *ngFor="let ship of shipTypes">
                  <option *ngIf="displayedLang==Languages.English" [value]="ship.Id">
                    {{ship.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="ship.Id">
                    {{ship.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div
                *ngIf="isTabTwoSubmitted ||(f.ShipTypeId?.dirty && (f.ShipTypeId?.errors || f.ShipTypeId?.value=='null'))"
                class="red ">
                <div *ngIf="f.ShipTypeId?.errors?.required || f.ShipTypeId?.value=='null'">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div *ngIf="showVesselOther" class="form-group">
              <label for="VesselTypeOther">{{'FRONT_USER.FEES_ESTIMATION_FORM.VESSEL_OTHER'| translate}}</label>
              <span class="red">*</span>
              <input type="text" name="VesselTypeOther" id="VesselTypeOther" class="form-control"
                formControlName="VesselTypeOther" />
              <div *ngIf="isTabTwoSubmitted ||(f.VesselTypeOther?.dirty && f.VesselTypeOther?.errors )" class="red ">
                <div *ngIf="f.VesselTypeOther?.errors?.required ">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- Fuel Type -->

            <div class="form-group">
              <label for="FuelTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.FUELTYPE'| translate}}</label>
              <span class="red">*</span>
              <ng-multiselect-dropdown id="FuelTypes" formControlName ="FuelTypeIds"
                placeholder="{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FUEL_TYPE_CHOOSE' | translate }}"
                [settings]="fuelTypesDropdownSettings" [data]="fuelTypes" [disabled]="formMode == 2"
                [(ngModel)]="selectedFuelTypes" (onDropDownClose)="fuelTypesChanged()">
              </ng-multiselect-dropdown>
              <div
                *ngIf="isTabTwoSubmitted ||(f.FuelTypes?.dirty && (f.FuelTypes?.errors || selectedFuelTypes?.length < 1))"
                class="red ">
                <div *ngIf="f.FuelTypes?.errors?.required || selectedFuelTypes?.length < 1">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- Other Fuel Type -->

            <div class="form-group" *ngIf="showOtherFuelType">
              <label for="FuelTypeOther">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FUEL_TYPE_Other' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="FuelTypeOther" id="FuelTypeOther" class="form-control"
                formControlName="FuelTypeOther" />
              <div *ngIf="isTabTwoSubmitted || (f.FuelTypeOther?.dirty && f.FuelTypeOther?.errors)" class="red ">
                <div *ngIf="f.FuelTypeOther?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <!-- IMO CII -->

            <div class="form-group">
              <label for="IMOCII">{{'FRONT_USER.FEES_ESTIMATION_FORM.IMOCII'| translate}}</label>
              <span class="red">*</span>
              <select formControlName="IMOCII" class="form-control">
                <option [value]='null' selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.IMOCII_CHOOSE' | translate}}
                </option>
                <ng-container *ngFor="let iMOCIIKey of imoCIIKeys">
                  <option [value]="imoCII[iMOCIIKey]">
                    {{iMOCIIKey}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.IMOCII?.dirty && (f.IMOCII?.errors || f.IMOCII?.value=='null'))"
                class="red ">
                <div *ngIf="f.IMOCII?.errors?.required || f.IMOCII?.value=='null'">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ShipStatus">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_STATUS' | translate }}</label>
              <span class="red"> *</span>
              <div class="form-custom-inputs">
                <div *ngFor="let status of shipStatusKeys;let i='index'" class=" custom-Radio">
                  <input type="radio" [id]=[status] name="ShipStatus"  [value]="shipStatus[status]"
                     formControlName="ShipStatus" (change)="changeStatus(shipStatus[status])" />
                  <label [for]="[status]">{{'FRONT_USER.FEES_ESTIMATION_FORM.'+ status | translate }}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.ShipStatus?.dirty && f.ShipStatus?.errors)" class="red ">
                <div *ngIf="f.ShipStatus?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>


            </div>

            <div class="form-group">
              <label for="PropellerTypeId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PROPELLER_TYPE' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="PropellerTypeId" class="form-control" id="dPropellertypeid"
                name="PropellerTypeId">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_PROPELLERTYPE' | translate}}</option>
                <ng-container *ngFor="let Propeller of PropellerTypes">
                  <option *ngIf="displayedLang==Languages.English" [value]="Propeller?.Id">
                    {{Propeller?.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="Propeller?.Id">
                    {{Propeller?.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.PropellerTypeId?.dirty && f.PropellerTypeId?.errors)" class="red ">
                <div *ngIf="f.PropellerTypeId?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="IsScrubberInstalled">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SCRUBBER_INSTALLED' | translate
                }}</label>
              <span class="red"> *</span>
              <div class="form-custom-inputs">
                <div *ngFor="let scrubberKey of yesNoOptionKeys;let i=index" class="custom-Radio">
                  <input type="radio"  [id]="'scrubberRadio'+i" name="IsScrubberInstalled"
                     [value]="options[scrubberKey]"  formControlName="IsScrubberInstalled" />
                  <label [for]="'scrubberRadio'+i">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ scrubberKey |
                    translate}}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsScrubberInstalled?.dirty && f.IsScrubberInstalled?.errors)"
                class="red ">
                <div *ngIf="f.IsScrubberInstalled?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>

            </div>

            <div *ngIf="showPassengers" class="form-group">
              <label for="PassengersNumber">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PASSENGERS_NUMBER' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="PassengersNumber" id="PassengersNumber" class="form-control"
                formControlName="PassengersNumber" />
              <div *ngIf="isTabTwoSubmitted ||(f.PassengersNumber?.dirty &&f.PassengersNumber?.errors)" class="red ">
                <div *ngIf="f.PassengersNumber?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}

                </div>
                <div *ngIf="f.PassengersNumber?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>

              </div>
            </div>

            <div class="form-group">
              <label for="ShipmentTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.SHIPMENT_TYPE'| translate}}</label>
              <span class="red"> *</span>
              <select (change)="ChangingShipment($event)" formControlName="ShipmentTypeId" class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_SHIMPMENT_TYPE' | translate}}
                </option>
                <ng-container *ngFor="let shimpment of shipmentTypes">
                  <option *ngIf="displayedLang==Languages.English" [value]="shimpment.Id">
                    {{shimpment.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="shimpment.Id">
                    {{shimpment.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.ShipmentTypeId?.dirty && f.ShipmentTypeId?.errors )" class="red ">
                <div *ngIf="f.ShipmentTypeId?.errors?.required ">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div *ngIf="showShipmentOther" class="form-group">
              <label for="ShipmentOther">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIPMENT_OTHER' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="ShipmentOther" id="ShipmentOther" class="form-control"
                formControlName="ShipmentOther" />
              <div *ngIf="isTabTwoSubmitted || (f.ShipmentOther?.dirty && f.ShipmentOther?.errors)" class="red ">
                <div *ngIf="f.ShipmentOther?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>


            <div class="form-group">
              <label for="ShipmentQuantity">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIPMENT_QUANTITY' | translate}}</label>
              <span class="red"> *</span>
              <div class="input-group">
                <input type="text" name="ShipmentQuantity" id="ShipmentQuantity" class="form-control"
                  formControlName="ShipmentQuantity" />
                <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.ShipmentQuantity?.dirty &&f.ShipmentQuantity?.errors)" class="red ">
                <div *ngIf="f.ShipmentQuantity?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.ShipmentQuantity?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="dDirectionId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DIRECTION' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="DirectionId" class="form-control" id="dDirectionId" name="Direction"
                (change)="checkFeesEstimationOfSameVessel()">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_DIRECTION' | translate}}</option>
                <!-- <option *ngFor="let sailDirection of directions" [value]="sailDirection?.Id">
                  {{sailDirection?.Direction}}
                </option> -->

                <ng-container *ngFor="let sailDirection of directions">
                  <option *ngIf="displayedLang==Languages.English" [value]="sailDirection?.Id">
                    {{sailDirection?.Direction}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="sailDirection?.Id">
                    {{sailDirection?.DirectionAR}}
                  </option>
                </ng-container>

              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.DirectionId?.dirty && f.DirectionId?.errors)" class="red ">
                <div *ngIf="f.DirectionId?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ContainerReduction">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.ContainerReduction' |
                translate}}</label>
              <span class="red">*</span>
              <input type="text" name="ContainerReduction" id="ContainerReduction" class="form-control"
                formControlName="ContainerReduction" />
              <div *ngIf="isTabTwoSubmitted || (f.ContainerReduction?.dirty && f.ContainerReduction?.errors)"
                class="red ">
                <div *ngIf="f.ContainerReduction?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.ContainerReduction?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="IsMilitaryShip">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.NAVY_OR_CHARTER' | translate }}</label>
              <span class="red"> *</span>
              <div class="form-custom-inputs">
                <div *ngFor="let militaryKey of yesNoOptionKeys;let i=index" class="custom-Radio">
                  <input type="radio"  [id]="'militaryShipRadio'+i" name="IsMilitaryShip"
                     [value]="options[militaryKey]"  formControlName="IsMilitaryShip" />
                  <label [for]="'militaryShipRadio'+i">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ militaryKey |
                    translate}}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsMilitaryShip?.dirty && f.IsMilitaryShip?.errors)" class="red ">
                <div *ngIf="f.IsMilitaryShip?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>


            </div>


            <div class="form-group">
              <label for="MilitaryShipmentTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.MILITARY_SHIPMENT_TYPE'|
                translate}}</label>
              <span class="red">*</span>

              <select (change)="ChangingOtherMilitary($event)" formControlName="MilitaryShipmentTypeId"
                class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_MILITARY_TYPE' | translate}}
                </option>
                <ng-container *ngFor="let militaryType of militaryTypes">
                  <option *ngIf="displayedLang==Languages.English" [value]="militaryType.Id">
                    {{militaryType.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="militaryType.Id">
                    {{militaryType.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.MilitaryShipmentTypeId?.dirty && f.MilitaryShipmentTypeId?.errors )"
                class="red ">
                <div *ngIf="f.MilitaryShipmentTypeId?.errors?.required ">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <div *ngIf="showMilitaryShipmentOther" class="form-group">
              <label for="MilitaryShipmentOther">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.MILITARY_SHIPMENT_OTHER' |
                translate}}</label>
              <span class="red">*</span>
              <input type="text" name="MilitaryShipmentOther" id="MilitaryShipmentOther" class="form-control"
                formControlName="MilitaryShipmentOther" />
              <div *ngIf="isTabTwoSubmitted || (f.MilitaryShipmentOther?.dirty && f.MilitaryShipmentOther?.errors)"
                class="red ">
                <div *ngIf="f.MilitaryShipmentOther?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>


            <div class="form-group">
              <label for="MilitaryShipmentQuantity">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.MILITARY_SHIPMENT_QUANTITY' |
                translate}}</label>
              <span class="red">*</span>
              <div class="input-group">
                <input type="text" name="MilitaryShipmentQuantity" id="MilitaryShipmentQuantity" class="form-control"
                  formControlName="MilitaryShipmentQuantity" />
                <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.MilitaryShipmentQuantity?.dirty &&f.MilitaryShipmentQuantity?.errors)"
                class="red ">
                <div *ngIf="f.MilitaryShipmentQuantity?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.MilitaryShipmentQuantity?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>



            <div class="form-group">
              <label for="IsRoofFloatingUnits">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FLOATING_UNITS' | translate
                }}</label>
              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let floatingKey of yesNoOptionKeys;let i=index" class="custom-Radio">
                  <input type="radio" [id]="'RoofFloatingRadio'+i"  name="IsRoofFloatingUnits"
                     [value]="options[floatingKey]"  formControlName="IsRoofFloatingUnits"
                    (change)="changeFloating(options[floatingKey])" />
                  <label [for]="'RoofFloatingRadio'+i">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ floatingKey |
                    translate}}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsRoofFloatingUnits?.dirty && f.IsRoofFloatingUnits?.errors)"
                class="red ">
                <div *ngIf="f.IsRoofFloatingUnits?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>


            </div>

            <div *ngIf="showFloat" class="form-group">
              <label for="TotalSuezAmount">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.TOTAL_SUEZ_AMOUNT' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="TotalSuezAmount" id="TotalSuezAmount" class="form-control"
                formControlName="TotalSuezAmount" />

              <div *ngIf="isTabTwoSubmitted ||(f.TotalSuezAmount?.dirty &&f.TotalSuezAmount?.errors)" class="red ">
                <div *ngIf="f.TotalSuezAmount?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <div *ngIf="showFloat" class="form-section">
              <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.DIMENSIONS'| translate}}</h4>


              <div class="form-group">
                <label for="FloatingUnitLength">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FLOATING_LENGTH' |
                  translate}}</label>
                <span class="red">*</span>
                <input type="text" name="FloatingUnitLength" id="FloatingUnitLength" class="form-control"
                  formControlName="FloatingUnitLength" />
                <div *ngIf="isTabTwoSubmitted ||(f.FloatingUnitLength?.dirty &&f.FloatingUnitLength?.errors)"
                  class="red ">
                  <div *ngIf="f.FloatingUnitLength?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>

                </div>
              </div>

              <div class="form-group">
                <label for="FloatingUnitWidth">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FLOATING_WIDTH' | translate}}</label>
                <span class="red">*</span>
                <input type="text" name="FloatingUnitWidth" id="FloatingUnitWidth" class="form-control"
                  formControlName="FloatingUnitWidth" />
                <div *ngIf="isTabTwoSubmitted ||(f.FloatingUnitWidth?.dirty &&f.FloatingUnitWidth?.errors)"
                  class="red ">
                  <div *ngIf="f.FloatingUnitWidth?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>

                </div>
              </div>
              <div class="form-group">
                <label for="FloatingUnitHeight">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.FLOATING_HEIGHT' |
                  translate}}</label>
                <span class="red">*</span>
                <input type="text" name="FloatingUnitHeight" id="FloatingUnitHeight" class="form-control"
                  formControlName="FloatingUnitHeight" />
                <div *ngIf="isTabTwoSubmitted ||(f.FloatingUnitHeight?.dirty &&f.FloatingUnitHeight?.errors)"
                  class="red ">
                  <div *ngIf="f.FloatingUnitHeight?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>

                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="IsEmptyConatiners">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.EMPTY_CONTAINER' | translate }}</label>
              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let emptyKey of yesNoOptionKeys;let i=index" class="custom-Radio">
                  <input type="radio" [id]="'EmptyConatinersRadio'+i"  name="IsEmptyConatiners"
                     [value]="options[emptyKey]"  formControlName="IsEmptyConatiners"
                    (change)="changeEmpty(options[emptyKey])" />
                  <label [for]="'EmptyConatinersRadio'+i">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ emptyKey | translate
                    }}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsEmptyConatiners?.dirty && f.IsEmptyConatiners?.errors)" class="red ">
                <div *ngIf="f.IsEmptyConatiners?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>
            </div>

            <div *ngIf="ShowFloors" class="form-group">
              <label for="FloorsNumber">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DECK_TIERS_NUMBER' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="FloorsNumber" id="FloorsNumber" class="form-control"
                formControlName="FloorsNumber" />
              <div *ngIf="isTabTwoSubmitted ||(f.FloorsNumber?.dirty &&f.FloorsNumber?.errors)" class="red ">
                <div *ngIf="f.FloorsNumber?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.FloorsNumber?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="IsRoofContainers">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.ANY_CONTAINER_DECK' | translate
                }}</label>
              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let roofKey of yesNoOptionKeys;let i=index" class="custom-Radio">
                  <input type="radio" [id]="'RoofContainersRadio'+i"  name="IsRoofContainers"
                     [value]="options[roofKey]"  formControlName="IsRoofContainers" />
                  <label [for]="'RoofContainersRadio'+i">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ roofKey | translate
                    }}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsRoofContainers?.dirty &&f.IsRoofContainers?.errors)" class="red ">
                <div *ngIf="f.IsRoofContainers?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="RoofContainerFloorsNumber">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.CONTAINER_TIRES_NUMBER' |
                translate}}</label>
              <span class="red">*</span>
              <select formControlName="RoofContainerFloorsNumber" class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_CONTAINER_FLOORS' | translate}}
                </option>
                <ng-container *ngFor="let floor of FloorsNumber">
                  <option *ngIf="displayedLang==Languages.English" [value]="floor.Id">
                    {{floor.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="floor.Id">
                    {{floor.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div
                *ngIf="isTabTwoSubmitted ||(f.RoofContainerFloorsNumber?.dirty &&f.RoofContainerFloorsNumber?.errors)"
                class="red ">
                <div *ngIf="f.RoofContainerFloorsNumber?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div
              *ngIf="ShowGasFreeOptions && (feesEstimationForm.get('IsGasShip')?.value !== null || formMode !== FormMode.Readonly)"
              class="form-group">
              <label for="IsGasShip">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_GAS_TYPE' | translate }}</label>
              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let gasShip of shipGasTypeKeys;let i='index'"  class=" custom-Radio">
                  <input type="radio" [id]=[gasShip]  name="IsGasShip"  [value]="shipGasType[gasShip]"
                    formControlName="IsGasShip" (change)="changeGasShip(shipGasType[gasShip])" />
                  <label [for]="[gasShip]">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.'+ gasShip | translate}}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.IsGasShip?.dirty &&f.IsGasShip?.errors)" class="red ">
                <div *ngIf="f.IsGasShip?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div *ngIf="ShowGas" class="form-group">
              <label for="GasType">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VAPOR_TYPE' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="GasType" id="GasType" class="form-control" formControlName="GasType" />
              <div *ngIf="isTabTwoSubmitted ||(f.GasType?.dirty &&f.GasType?.errors)" class="red ">
                <div *ngIf="f.GasType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div *ngIf="ShowGas" class="form-group">
              <label for="GazAmount">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VAPOR_QUANTITY' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="GazAmount" id="GazAmount" class="form-control" formControlName="GazAmount" />
              <div *ngIf="isTabTwoSubmitted ||(f.GazAmount?.dirty &&f.GazAmount?.errors)" class="red ">
                <div *ngIf="f.GazAmount?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.GazAmount?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="ShipNationalityId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_NATIONALITY' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="ShipNationalityId" class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_NATIONALITY' | translate}}
                </option>
                <ng-container *ngFor="let nationality of nationalities">
                  <option *ngIf="displayedLang==Languages.English" [value]="nationality.Id">
                    {{nationality.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="nationality.Id">
                    {{nationality.NameAR}}
                  </option>
                </ng-container>

              </select>
              <div *ngIf="isTabTwoSubmitted ||(f.ShipNationalityId?.dirty &&f.ShipNationalityId?.errors)" class="red ">
                <div *ngIf="f.ShipNationalityId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="Height">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LENGTH' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="Height" id="Height" class="form-control" formControlName="Height" />
              <div *ngIf="isTabTwoSubmitted ||(f.Height?.dirty &&f.Height?.errors)" class="red ">
                <div *ngIf="f.Height?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.Height?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="Width">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.BEAM' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="Width" id="Width" class="form-control" formControlName="Width" />
              <div *ngIf="isTabTwoSubmitted ||(f.Width?.dirty &&f.Width?.errors)" class="red ">
                <div *ngIf="f.Width?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.Width?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="TotalSuezCanalAmout">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SUEZ_CANAL_TONNAGE' |
                translate}}</label>
              <span class="red">*</span>
              <div class="input-group">
                <input type="text" name="TotalSuezCanalAmout" id="TotalSuezCanalAmout" class="form-control"
                  formControlName="TotalSuezCanalAmout" />
                <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
              </div>

              <div *ngIf="isTabTwoSubmitted ||(f.TotalSuezCanalAmout?.dirty &&f.TotalSuezCanalAmout?.errors)"
                class="red ">
                <div *ngIf="f.TotalSuezCanalAmout?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.TotalSuezCanalAmout?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="SuezCanalNetTonnage">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SUEZ_CANAL_NET' | translate}}</label>
              <span class="red">*</span>
              <div class="input-group">
                <input type="text" name="SuezCanalNetTonnage" id="SuezCanalNetTonnage" class="form-control"
                  formControlName="SuezCanalNetTonnage" />
                <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>
              </div>

              <div *ngIf="isTabTwoSubmitted ||(f.SuezCanalNetTonnage?.dirty &&f.SuezCanalNetTonnage?.errors)"
                class="red ">
                <div *ngIf="f.SuezCanalNetTonnage?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.SuezCanalNetTonnage?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ETA">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.ETA' | translate }}</label>
              <span class="red">*</span>
              <div class="split-form-group ">
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="ETA"
                  (ngModelChange)="compareTwoDates()">
                <timepicker id="ETATime" formControlName="ETATime" [hourStep]="1" [minuteStep]="1"></timepicker>
              </div>

              <div *ngIf="isTabTwoSubmitted ||(f.ETA?.dirty && f.ETA?.errors)" class="red ">
                <div *ngIf="f.ETA?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.ETA?.errors?.inValidDateError">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.ETATime?.dirty && f.ETATime?.errors)" class="red ">
                <div *ngIf="f.ETATime?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
              <div *ngIf="error.isError" class="red">
                {{ error.errorMessage }}
              </div>
            </div>

            <div class="form-group">
              <label for="TransitDate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.TRANSIT_DATE' | translate}}</label>
              <span class="red"> *</span>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="TransitDate"
                (ngModelChange)="compareTwoDates()">

              <div *ngIf="isTabTwoSubmitted ||(f.TransitDate?.dirty && f.TransitDate?.errors)" class="red ">
                <div *ngIf="f.TransitDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.TransitDate?.errors?.inValidDateError">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>

            </div>

            <div class="form-group">
              <label for="LastTransitDate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LAST_TRANSIT_DATE' | translate}}</label>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="LastTransitDate"
                [minDate]="null" [maxDate]="todayDate" (ngModelChange)="compareLastTransit()">

              <div *ngIf="isTabTwoSubmitted ||(f.LastTransitDate?.dirty && f.LastTransitDate?.errors)" class="red ">
                <div *ngIf="f.LastTransitDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.LastTransitDate?.errors?.invalid">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>
              <div *ngIf="errorLastTransit.isError" class="red">
                {{ errorLastTransit.errorMessage }}
              </div>
            </div>


            <div class="form-group">
              <label for="GraveMaterial">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DANGERIOUS_LIST' | translate}}</label>
              <span class="red"> *</span>
              <textarea formControlName="GraveMaterial" class="form-control"></textarea>
              <div *ngIf="isTabTwoSubmitted ||(f.GraveMaterial?.dirty &&f.GraveMaterial?.errors)" class="red ">
                <div *ngIf="f.GraveMaterial?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.GraveMaterial?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="DraftUnit">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DRAFT_UNIT' | translate }}</label>
              <span class="red"> *</span>
              <div class="form-custom-inputs">
                <div *ngFor="let unit of draftUnitKeys;let i='index'" class=" custom-Radio">
                  <input type="radio" [id]=[unit] name="DraftUnit"  [value]="DraftUnit[unit]"
                     formControlName="DraftUnit" (change)="feesEstimationForm.get('SubmersibleAccess').enable()" />
                  <label [for]="[unit]">{{'FRONT_USER.FEES_ESTIMATION_FORM.'+ unit | translate }}</label>

                </div>
              </div>
              <div *ngIf="isTabTwoSubmitted ||(f.DraftUnit?.dirty && f.DraftUnit?.errors)" class="red ">
                <div *ngIf="f.DraftUnit?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="SubmersibleAccess">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.ARRIVAL_DRAFT' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="SubmersibleAccess" id="SubmersibleAccess" class="form-control"
                formControlName="SubmersibleAccess"
                [attr.disabled]="!feesEstimationForm.get('DraftUnit')?.value ? true : null" />
              <div *ngIf="isTabTwoSubmitted ||(f.SubmersibleAccess?.dirty &&f.SubmersibleAccess?.errors)" class="red ">
                <div *ngIf="f.SubmersibleAccess?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.SubmersibleAccess?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
              </div>
            </div>


            <div class="form-group">
              <label for="Flake">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.MOORING_BOATS' | translate}}</label>
              <input type="text" name="Flake" id="Flake" class="form-control" formControlName="Flake" />
              <div *ngIf="isTabTwoSubmitted ||(f.Flake?.dirty &&f.Flake?.errors)" class="red ">
                <div *ngIf="f.Flake?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="Scouts">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PROJECTOR' | translate}}</label>
              <input type="text" name="Scouts" id="Scouts" class="form-control" formControlName="Scouts" />
              <div *ngIf="isTabTwoSubmitted ||(f.Scouts?.dirty &&f.Scouts?.errors)" class="red ">
                <div *ngIf="f.Scouts?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="LastCountry">{{'FRONT_USER.FEES_ESTIMATION_FORM.LAST_COUNTRY' | translate}}</label>
              <span class="red"> *</span>
              <select formControlName="LastCountry" id="LastCountry" name="LastCountry" class="form-control"
                [ngClass]="{ 'is-invalid': submitted ||( f.LastCountry?.dirty  && f.LastCountry?.errors) }">
                <option [value]='null' selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.LAST_COUNTRY_CHOOSE' |translate}}
                </option>
                <ng-container *ngFor="let count of Countries">
                  <option *ngIf="displayedLang==Languages.English" [value]="count.Id">
                    {{count.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="count.Id">
                    {{count.NameAR}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="isTabTwoSubmitted || (f.LastCountry?.dirty && f.LastCountry?.invalid)" class="red">
                <div *ngIf="f.LastCountry?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ComingFrom">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LAST_PORT' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="ComingFrom" id="ComingFrom" class="form-control" formControlName="ComingFrom" />
              <div *ngIf="isTabTwoSubmitted ||(f.ComingFrom?.dirty &&f.ComingFrom?.errors)" class="red ">
                <div *ngIf="f.ComingFrom?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.ComingFrom?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="NextCountry">{{'FRONT_USER.FEES_ESTIMATION_FORM.NEXT_COUNTRY' | translate}}</label>
              <span class="red"> *</span>
              <select formControlName="NextCountry" id="NextCountry" name="NextCountry" class="form-control"
                [ngClass]="{ 'is-invalid': submitted ||( f.NextCountry?.dirty  && f.NextCountry?.errors) }">
                <option [value]='null' selected>
                  {{'FRONT_USER.FEES_ESTIMATION_FORM.NEXT_COUNTRY_CHOOSE' |translate}}
                </option>
                <ng-container *ngFor="let count of Countries">
                  <option *ngIf="displayedLang==Languages.English" [value]="count.Id">
                    {{count.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="count.Id">
                    {{count.NameAR}}
                  </option>
                </ng-container>
              </select>
              <div
                *ngIf="isTabTwoSubmitted || ( f.NextCountry?.dirty && (f.NextCountry?.errors || f.NextCountry?.value=='null'))"
                class="red ">
                <div *ngIf="f.NextCountry?.errors?.required || f.NextCountry?.value=='null' ">
                  {{'FRONT_USER.This_Field_Is_Required' |translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="DestinedTo">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.NEXT_PORT' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="DestinedTo" id="DestinedTo" class="form-control" formControlName="DestinedTo" />
              <div *ngIf="isTabTwoSubmitted ||(f.DestinedTo?.dirty &&f.DestinedTo?.errors)" class="red ">
                <div *ngIf="f.DestinedTo?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.DestinedTo?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="AgentEscortTugs">
                {{ 'FRONT_USER.FEES_ESTIMATION_FORM.AGENT_ESCORT_TUGS' | translate }}
              </label>
              <input type="text" name="AgentEscortTugs" id="AgentEscortTugs" class="form-control" maxlength="1"
                formControlName="AgentEscortTugs" />
              <div *ngIf="isTabTwoSubmitted || (f.AgentEscortTugs?.dirty && f.AgentEscortTugs?.errors)" class="red">
                <div *ngIf="f.AgentEscortTugs?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
                </div>
                <div *ngIf="f.AgentEscortTugs?.errors?.pattern">
                  {{ 'FRONT_USER.NUMBER_ERROR' | translate }}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label><span class="red">*</span>
                <input type="checkbox" id="CommitToCoverFees" formControlName="CommitToCoverFees" />
                {{ 'FRONT_USER.FEES_ESTIMATION_FORM.COMMIT_TO_COVER_FEES' | translate }}
              </label>

              <!-- Validation message if not checked -->
              <div *ngIf="isTabTwoSubmitted ||(f.CommitToCoverFees?.dirty &&f.CommitToCoverFees?.errors)" class="red ">
                <div *ngIf="f.CommitToCoverFees?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.CommitToCoverFees?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>

              <!-- Confirmation message shown when checked -->
              <div *ngIf="feesEstimationForm.get('CommitToCoverFees')?.value" class="alert alert-info mt-2">
                {{ 'FRONT_USER.FEES_ESTIMATION_FORM.PRELIMINARY_FEES_MESSAGE' | translate }}
              </div>
            </div>
            <!--------------------------------------------------------------------------------------------------------------------------------------------->

            <!-- Principal Section -->
            <div class="form-container">
              <div class="form-section">
                <h4 class="section-title">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PRINCIPAL_SECTION_TITLE' | translate}}
                </h4>
                <!-- Name -->
                <div class="form-group">
                  <label for="PrincipalName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PRINCIPAL_NAME' | translate}}</label>
                  <span class="red"> *</span>
                  <input type="text" name="PrincipalName" id="PrincipalName" class="form-control"
                    formControlName="PrincipalName" />
                  <div *ngIf="formMode==FormMode.Add || formMode==FormMode.Edit" class="blue italic">
                    <span>
                      {{ 'FRONT_USER.FEES_ESTIMATION_FORM.PRINCIPAL_NAME_DESC' | translate}}
                    </span>
                  </div>
                  <div *ngIf="isTabTwoSubmitted ||(f.PrincipalName?.dirty &&f.PrincipalName?.errors)" class="red ">
                    <div *ngIf="f.PrincipalName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.PrincipalName?.errors?.startsWithSpaceError">
                      {{'FRONT_USER.START_WITH_SPACE' | translate}}
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="form-group">
                  <label for="PrincipalEMail">Email</label>
                  <span class="red"> *</span>
                  <input type="text" formControlName="PrincipalEMail" name="PrincipalEMail" id="PrincipalEMail"
                    class="form-control" />
                  <div *ngIf="isTabTwoSubmitted ||(f.PrincipalEMail?.dirty &&f.PrincipalEMail?.errors)" class="red ">
                    <div *ngIf="f.PrincipalEMail?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.PrincipalEMail?.errors?.pattern">
                      {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                    </div>
                    <div *ngIf="f.PrincipalEMail?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' |
                      translate}}</div>
                  </div>
                </div>
                <!-- Fax -->
                <div class="form-group">
                  <label for="PrincipalFax">Fax</label>
                  <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                  <input type="text" formControlName="PrincipalFax" name="PrincipalFax" id="PrincipalFax"
                    class="form-control" />
                  <div *ngIf="isTabTwoSubmitted ||(f.PrincipalFax?.dirty &&f.PrincipalFax?.errors)" class="red ">
                    <span *ngIf="f.PrincipalFax?.errors?.pattern">{{'FRONT_USER.VALID_FAX_NUMBER' | translate}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <p class="btns-holder text-right">
            <button type="button" class="btn  SCAcustomBtn" (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' |
              translate}}</button>
            <button type="button" class="btn  SCAcustomBtn" (click)="selectTab(2)">{{ 'FRONT_USER.NEXT' |
              translate}}</button>
          </p>
        </tab>

        <tab #tabThreeControls heading="{{ 'FRONT_USER.FEES_ESTIMATION_TABS.REQUIRED_DOCUMENTS' | translate}}"
          [disabled]="(ValidateTabTwo && !isTabOneValid) || ( ValidateTabTwo || !isTabOneValid)">

          <div class="bs-callout bs-callout-info">
            <h4>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENTS_TO_BE_UPLOADED' | translate}}</h4>
            <ul>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SUEZ_CANAL_TONNAGE_CERT' | translate}}</li>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_REGISTER' | translate}}</li>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.CLASS_CERT_HULL_MACH' | translate}}</li>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.CARGO_MANIFEST' | translate}}</li>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.B_L_CERT' | translate}}</li>
              <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.STOWAGE_PLAN' | translate}}</li>
            </ul>
          </div>
          <div formArrayName="Attachments">
            <!-- <div *ngFor="let attachment of feesEstimationForm.get('Attachments').controls; let i=index; let last = last"
              [formGroupName]="i"> -->
            <div
              *ngFor="let attachment of feesEstimationForm.get('Attachments')['controls']; let i=index; let last = last"
              [formGroupName]="i">
              <div class="form-container">

                <div class="form-group">
                  <label for="DocumentName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT_NAME' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="DocumentName" class="form-control"
                    [ngClass]="{ 'is-invalid':formSubmitted ||( attachment.get('DocumentName')?.dirty && attachment.get('DocumentName')?.errors) }" />
                  <div
                    *ngIf=" formSubmitted ||(attachment.get('DocumentName')?.dirty && attachment.get('DocumentName')?.errors)"
                    class="red ">
                    <div *ngIf="attachment.get('DocumentName')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                  </div>
                </div>


                <div *ngIf="formMode != FormMode.Readonly" class="form-group">
                  <label for="URL">{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'| translate}}</label>
                  <span class="red"> *</span>

                  <input type="file"
                    accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                    MaxSizeInMB="5" class="form-control" id="URL" formControlName="URL"
                    (change)="onFileSelected($event,attachment.get('URL'),i,'documentsProgress'+i)" />
                  <div class="upload-info">
                    <span data-toggle="tooltip"
                      title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
                      | translate}}</span>
                    <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
                  </div>
                  <div class="progress">
                    <div *ngIf="i==0" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress0+'%'">

                      <span class=""> {{ documentsProgress0 }} % Complete</span>
                    </div>
                    <div *ngIf="i==1" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress1+'%'">

                      <span class=""> {{ documentsProgress1 }} % Complete</span>
                    </div>
                    <div *ngIf="i==2" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress2+'%'">

                      <span class=""> {{ documentsProgress2 }} % Complete</span>
                    </div>
                    <div *ngIf="i==3" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress3+'%'">

                      <span class=""> {{ documentsProgress3 }} % Complete</span>
                    </div>
                    <div *ngIf="i==4" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress4+'%'">

                      <span class=""> {{ documentsProgress4 }} % Complete</span>
                    </div>
                    <div *ngIf="i==5" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress5+'%'">

                      <span class=""> {{ documentsProgress5 }} % Complete</span>
                    </div>
                    <div *ngIf="i==6" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress6+'%'">

                      <span class=""> {{ documentsProgress6 }} % Complete</span>
                    </div>
                    <div *ngIf="i==7" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress7+'%'">

                      <span class=""> {{ documentsProgress7 }} % Complete</span>
                    </div>
                    <div *ngIf="i==8" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress8+'%'">

                      <span class=""> {{ documentsProgress8 }} % Complete</span>
                    </div>
                    <div *ngIf="i==9" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="documentsProgress9+'%'">

                      <span class=""> {{ documentsProgress9 }} % Complete</span>
                    </div>
                  </div>


                  <div *ngIf=" formSubmitted ||(attachment.get('URL')?.dirty &&  attachment.get('URL')?.errors)"
                    class="red">
                    <div *ngIf="attachment.get('URL')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required'| translate}}
                    </div>
                    <div *ngIf="attachment.get('URL').errors?.notCompleted">
                      {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                    </div>
                  </div>
                </div>

                <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
                  <label>{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'|translate}}</label>

                  <a [attr.href]="uploadUrl+uploadFolder+'/'+RequestAttachments[i]?.URL" target="_blank">
                    <i class="icon-view-file"></i>
                    {{RequestAttachments[i]?.DocumentName}}
                  </a>
                </div>
                <input type="hidden" formControlName="AttachmentTypeId" [ngModel]="AttachmentType">

                <p *ngIf="formMode != FormMode.Readonly">
                  <button type="button" class="btn SCAcustomBtn" Confirmation
                    (confirmationClick)="deleteAttachments(i,'documentsProgress'+i)"
                    *ngIf="getFeesEstimationAttachmentsLengthGetter > 1">
                    {{'FRONT_USER.DELETE' | translate }}
                  </button>
                </p>

              </div>
              <!-- *ngIf="!(i>8) && last" this condition for the agent can add up to 10 documents  -->
              <p *ngIf="!(i>8) && last && formMode != FormMode.Readonly " class="btns-holder text-right">
                <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="addAttachments()">(+)
                  {{'FRONT_USER.ADD' | translate }}</button>
              </p>

            </div>



          </div>

          <div class="form-group" *ngIf="formMode != FormMode.Readonly">
            <label for="TermsAndConditions">{{ 'FRONT_USER.TERMS_CONDITIONS' | translate }}</label>
            <span class="red"> *</span>

            <div class="form-custom-inputs">
              <div class="custom-checkbox">
                <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
                  formControlName="TermsAndConditions" />
                <label for="TermsAndConditions">
                  <a (click)="goToTermsAndCond()" target="_blank">
                    {{ 'FRONT_USER.TERMS_CONDITIONS_Acceptence' | translate }}
                  </a>
                </label>

              </div>
            </div>
            <div *ngIf="formSubmitted ||(f.TermsAndConditions.dirty && f.TermsAndConditions?.errors)" class="red ">
              <div *ngIf="f.TermsAndConditions?.errors?.required">
                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
            </div>
          </div>

          <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">{{ 'FRONT_USER.PREVIOUS' |
              translate}}</button>
          </p>

        </tab>

      </tabset>
    </div>
    <p class="form-group" *ngIf="formMode != FormMode.Readonly && validateSubmitButton ">
      <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' |
        translate}}</button>


    </p>

  </form>

  <div
    *ngIf="sameVesselHasRequest && sameVesselRequestsData.length > 0 && formMode == FormMode.Readonly && user.IsAdmin">
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.SAME_VESSEL_REQUESTS' | translate }}</h4>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th><span>{{'FRONT_USER.FEES_ESTIMATION_FORM.REQUEST_NUMBER' | translate }}</span></th>
            <th><span>{{'FRONT_USER.FEES_ESTIMATION_FORM.AGENT_NAME' | translate }}</span></th>
            <th><span>{{'FRONT_USER.FEES_ESTIMATION_FORM.SUBMISSION_DATE' | translate }}</span></th>
            <th><span>{{'FRONT_USER.FEES_ESTIMATION_FORM.REQUEST_STATUS' | translate }}</span></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of sameVesselRequestsData; let i = index;">
            <td>{{request.RequestNumber}}</td>
            <td>{{request.AgentName}}</td>
            <td>{{request.CreationDate | date:'dd/MM/yyyy'}}</td>
            <td *ngIf="displayedLang==Languages.English">{{request.Status?.StatusEN}}</td>
            <td *ngIf="displayedLang==Languages.Arabic">{{request.Status?.StatusAR}}</td>
            <td><a class="btn" (click)="goToFessEstimationOfSameIMONO(request.Id)">Details</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>


  </div>
</div>


<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="!showRequest && ( (!loggedInUser.IsAdmin && loggedInUser.UserId == agentId) || loggedInUser.IsAdmin )">
  <app-messaging></app-messaging>
</div>